







import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import { RevolvaService } from "@/service/revolva.service";
import * as actions from "@/service/revolva.action";
import * as actionsCustom from "@/service/revolva.action-custom";


@Component({
  components: {
   
  },
})
export default class ToolBar extends Vue {
  @Prop() readonly revolva: RevolvaService | undefined;


}
